import React, { useEffect, useState } from 'react';
import './AboutPage.css';
import NavBar from '../components/layout/NavBar';
import Footer from '../components/layout/Footer';
import logo from '../assets/images/logo.svg';
import car from '../assets/images/car_image.png';
import { getWhatsAppDetails } from '../services/api';

function AboutPage() {
  const [url, setUrl] = useState('');

  useEffect(() => {
    const fetchWhatsAppDetails = async () => {
        try {
          const { number, welcome_message } = await getWhatsAppDetails();
          setUrl(`https://wa.me/${number}?text=${encodeURIComponent(welcome_message)}`);
        } catch (error) {
          console.error('Failed to fetch WhatsApp details:', error);
        }
    };

    fetchWhatsAppDetails();
  }, []);

  return (
    <div className="about-container">
      <NavBar />
      <div className="about-content">
        <div className="about-about">
          <div className="about-about-column">
            <h1>Nosotros</h1>
            <img src={logo} alt="Brand logo" className="about-logo" />
          </div>
          <div className="about-about-column">
            <h2>Avikeli: Tu socio estratégico en gastronomía</h2>
            <p>En 2024, impulsados por las necesidades de nuestros clientes y nuestra visión de crecimiento, Papa Quick ® decidió dar un paso más allá. 
Así nació Avikeli, una distribuidora diseñada para brindar soluciones integrales en productos gastronómicos, respaldada por 30 años de experiencia y confianza en el mercado.
Con una sólida cartera de clientes y un equipo especializado, ampliamos nuestra oferta continuamente, estableciendo alianzas estratégicas con marcas líderes. 
Garantizamos que cada producto cumpla con los más altos estándares, adaptándonos a las necesidades de los diferentes segmentos del mercado.
Nuestro equipo, especialmente capacitado y comprometido, se dedica a brindar un servicio cálido y eficiente, desde la toma del pedido hasta la entrega puntual.
Con una visión en constante evolución, trabajamos cada día para ser el socio estratégico que nuestros clientes necesitan para alcanzar el éxito.</p>
          </div>
        </div>
        <div className="about-contact">
          <div className="about-about-column">
            <h1 style={{ color: "#ff6666" }}>Contacto</h1>
            <p>Estamos aquí para ayudarte! En Avikeli, nos especializamos en ofrecer soluciones en productos congelados, diseñados específicamente para el sector de food service. 
Sabemos lo importante que es mantenernos conectados contigo, por eso trabajamos para brindarte la mejor atención.
¡No dudes en contactarnos!</p>
            <ul class="contact-us-items">
              <li><strong>WhatsApp:</strong> +54 9 351 3422478</li>
              <li><strong>Correo electrónico:</strong> info@avikeli.com</li>
              <li><strong>Horario de atención al cliente:</strong> De lunes a viernes, de 6:00 a.m. a 2:00 p.m.</li>
            </ul>
            {/* {url ? (
              <a
                className="generic-button"
                href={url}
                target="_blank"
                rel="noreferrer"
              >
                Lorem Ipsum
              </a>
            ) : <></>} */}
          </div>
          <div className="about-about-column">
            <img src={car} alt="Contact visual" className="contact-image" />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default AboutPage;
